export default "__VITE_ASSET__3f6fc788__"